import styled, { css } from 'styled-components';

export const Button = styled.button<{ variant: 'fill' | 'ghost' }>`
  padding: var(--spacement-medium) var(--spacement-large);
  border-radius: var(--radius-small);
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.2s ease;
  cursor: pointer;

  ${({ variant }) =>
    variant === 'ghost'
      ? css`
          background-color: transparent;
          color: var(--primary-800-light);
          border: none;

          &:hover:not(:disabled) {
            background-color: var(--neutral-0);
          }
        `
      : css`
          background-color: var(--primary-800-light);
          color: var(--absolute-white);
          border: none;

          &:hover:not(:disabled) {
            background-color: var(--primary-200-light);
          }
        `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
      cursor: default;
    `}
`;
